import React, { PureComponent } from "react"
import { compose, withProps, lifecycle } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps"
import axios from 'axios'
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const KEY = `AIzaSyBC00e7pKKImievPmep2q25TlC7o5RGVOg`

async function handleGetNameLocation(latitude, longitude) {
  const { data } =  await axios({
    method: 'get',
    url: `https://maps.googleapis.com/maps/api/geocode/json?address=${latitude},${longitude}&key=AIzaSyD54YJaQdaLVKuUacJRaUYP4pvxqjgLI3s`,
  })
  
  const objLocation = data ? data.results[0] : {}
  return objLocation ? objLocation.formatted_address : ''
}

const MapWithAMarkers = compose(    
    withProps({
      googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${KEY}&v=3.exp&libraries=geometry,drawing,places`,
      loadingElement: <div style={{ height: `100%` }} />,
      containerElement: <div style={{ height: `400px` }} />,
      mapElement: <div style={{ height: `100%` }} />,
    }),
    lifecycle({
        componentDidMount() {
            this.setState({
                zoomToMarkers: map => {
                  if (map) {
                    const bounds = new window.google.maps.LatLngBounds();
                    map.props.children.forEach((child) => {
                        if (child.type === MarkerWithLabel) {
                            bounds.extend(new window.google.maps.LatLng(child.props.position.lat, child.props.position.lng));
                        }
                    })
                    map.fitBounds(bounds);
                  }  
                }
            })
        },
    }),
    withScriptjs,
    withGoogleMap
)(props =>
    <GoogleMap ref={props.zoomToMarkers} defaultZoom={5} defaultCenter={{ lat: 25.0391667, lng: 121.525 }}>
        {props.markers.map(marker => (
              
          <MarkerWithLabel
            key={marker.id}
            position={{ lat: marker.lat, lng: marker.lng }}
            labelAnchor={new window.google.maps.Point(0, 0)}
            labelStyle={{
              backgroundColor: marker.color,
              border: '10px',
              fontSize: "12px",
              padding: "4px",
              borderRadius: '4px',
              fontWeight: 'bold',
              color: marker.textColor,
              width: '200px',
              wordWrap: 'break-word'
            }}
          >
            <div>{marker.label}</div>
          </MarkerWithLabel>
                  
        ))}
    </GoogleMap>
    );

class Map extends PureComponent {
  
  state = {
    markers: [],
  }

  async componentDidMount() {
    const { initialLocation, finalLocation, createdAt, terminatedAt } = this.props;
    const marker = []
    
    if (initialLocation) {
      const nameInitialLocation = await handleGetNameLocation(initialLocation.latitude,initialLocation.longitude)
      marker.push({
        lat: initialLocation.latitude,
        lng: initialLocation.longitude,
        id: "initial",
        label: `Partida: ${createdAt} ${nameInitialLocation}`,
        color: "#39b6f2",
        textColor: "#fff"
      })
    
    }
    if (finalLocation) {
      const nameFinalLocation = await handleGetNameLocation(finalLocation.latitude,finalLocation.longitude)
      marker.push({
        lat: finalLocation.latitude,
        lng: finalLocation.longitude,
        id: "final",
        label: `Chegada: ${terminatedAt} ${nameFinalLocation}`,
        color: "#59AD6A",
        textColor: "#fff"
      })
    }
  
    if (marker.length>0) {
      this.setState({markers: marker})
    }
  }

  render() {
      return (
          this.state.markers.length > 0 && <MapWithAMarkers markers={this.state.markers} />
      )
  }
}

export default Map;
